import { TFunction } from "i18next";
import * as yup from "yup";

import {
  createTermsOfUse,
  TermsOfUse,
  TermsOfUseValidation,
} from "./TermsOfUse";

export interface General {
  termsOfUse: TermsOfUse;
  codeLabel: string;
  otherPatientId: number;
  requireNonDicomAnnotation: boolean;
}

export const createGeneral = (): General => ({
  termsOfUse: createTermsOfUse(),
  codeLabel: "",
  otherPatientId: 0,
  requireNonDicomAnnotation: false,
});

export const GeneralValidation = (t: TFunction) =>
  yup.object({
    termsOfUse: TermsOfUseValidation(t),
    codeLabel: yup.string(),
    otherPatientId: yup.number().min(0).max(2),
    requireNonDicomAnnotation: yup.boolean(),
  });
